module.exports = __webpack_public_path__ + "img/index-bg.7d909c89.png";